// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"396":"801a6084","532":"styles","678":"component---src-pages-index-js","702":"b2e984c5","883":"component---src-pages-404-js"}[chunkId] + "-" + {"396":"c1d8bfe310c5546584e3","532":"6db285c6ad62e00ab61f","678":"6a95ba76467e28f65213","702":"812a9746c17a59b005d8","883":"481d4a534f5369b2facf"}[chunkId] + ".js";
};